import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

/**
 * TagPill Component
 * Outlined style tag that can be a link or button
 */
const TagPill = ({
  tag,
  isActive = false,
  onClick,
  asLink = true,
  size = 'default', // 'small' | 'default' | 'large'
  className = '',
}) => {
  // Remove # from tag for URL
  const tagSlug = tag.replace('#', '').toLowerCase();

  const sizeClasses = {
    small: 'px-2 py-0.5 text-xs',
    default: 'px-3 py-1 text-sm',
    large: 'px-4 py-1.5 text-base',
  };

  const baseClasses = `
    inline-flex items-center font-medium rounded-full
    border transition-all duration-200
    ${sizeClasses[size]}
    ${isActive
      ? 'bg-accent text-dark-primary border-accent'
      : 'border-accent text-accent hover:border-accent-hover hover:bg-accent/10'
    }
    ${className}
  `.trim();

  const content = tag.startsWith('#') ? tag : `#${tag}`;

  if (asLink) {
    return (
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <Link
          to={`/episodes/tag/${tagSlug}`}
          className={baseClasses}
        >
          {content}
        </Link>
      </motion.div>
    );
  }

  return (
    <motion.button
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
      className={baseClasses}
    >
      {content}
    </motion.button>
  );
};

export default TagPill;
